import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { ContactContext } from "../../context/contact/ContactContext";
import { useAnalytics } from "../../utils/googleAnalytics";
import Wait from "../Wait";
import "./EstadoCuenta.css";
import EstadoCuentaTable from "./EstadoCuentaTable";

const EstadoCuenta = () => {
  useAnalytics("VSS-EstadoCuenta");
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(true);
  const [invoicesLocal, setInvoicesLocal] = useState([]);
  const { getInvoices } = useContext(ContactContext);

  useEffect(() => {
    if (JSON.parse(sessionStorage.getItem("invoices")) !== null) {
      const tmp = JSON.parse(sessionStorage.getItem("invoices"));
      setInvoicesLocal(tmp);
      setLoading(false);
    } else {
      getInvoices().then((response) => {
        setInvoicesLocal(response);
        setLoading(false);
      });
    }
  }, []);
  if (isLoading) {
    return <Wait />;
  }
  return (
    <div className="cssBodyTable">
      <br />
      <h1 className="cssTittle">{t("bankStatement")}</h1>
      <br />
      <EstadoCuentaTable data={invoicesLocal} rowsPerPage={30} />
    </div>
  );
};

export default EstadoCuenta;
